import React from "react"
import PropTypes from "prop-types"
import { ThemeProvider, createGlobalStyle } from "styled-components"
import {
  StoreProvider as BrandSitesStoreProvider,
  GlobalNotice,
  CookiesConsent,
} from "@outdoormap/gatsby-plugin-brand-sites"
import "@outdoormap/frontend-utils/scss/reset.scss"

import Header from "../header"
import Footer from "../footer"
import { Anchor } from "../styled/anchor"
import { Paragraph, ParagraphSmall } from "../styled/paragraph"
import { StoreProvider } from "../../store"
import theme from "../../theme"

const Layout = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <BrandSitesStoreProvider language={process.env.GATSBY_LANG}>
        <StoreProvider>
          <React.Fragment>
            <InitialStyles />

            <header>
              <GlobalNotice Anchor={Anchor} Paragraph={Paragraph} />

              <Header tagName="div" />
            </header>

            <main>{children}</main>

            <Footer />

            <CookiesConsent Text={ParagraphSmall} />
          </React.Fragment>
        </StoreProvider>
      </BrandSitesStoreProvider>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout

const InitialStyles = createGlobalStyle`
  @font-face {
     font-family: "Inter";
     font-style: normal;
     font-weight: 400;
     font-display: fallback;
     src: url("/fonts/Inter-Regular.woff2") format("woff2");
  }

  @font-face {
     font-family: "Inter";
     font-style: italic;
     font-weight: 400;
     font-display: fallback;
     src: url("/fonts/Inter-Italic.woff2") format("woff2");
  }

  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-display: fallback;
    src: url("/fonts/Inter-Bold.woff2") format("woff2");
  }

  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 900;
    font-display: fallback;
    src: url("/fonts/Inter-Black.woff2") format("woff2");
  }

  * {
    line-height: calc(2px + 2.3ex + 2px); /* https://hugogiraudel.com/2020/05/18/using-calc-to-figure-out-optimal-line-height/ */
  }

  *:focus:not(:focus-visible) {
    outline: none;
  }

  html {
    ${({ theme }) => theme.fonts.set(`primary`, `normal`)}

    font-size: 100%;  /* a11y */
    color: ${({ theme }) => theme.colors.firefly};
    background-color: ${({ theme }) => theme.colors.lightBeige};
  }

  html,
  body {
    width: 100%;
    overflow-x: hidden;
  }

  strong {
    ${({ theme }) => theme.fonts.set(`primary`, `bold`)}
  }
`
